import { supabase } from '../supabase/supabaseClient';
import { sendRegistrationEmail } from '../email/emailService';

export const getMemberApprovalList = async (search = '', limit = 10, offset = 0) => {
  let query = supabase
    .from('members')
    .select('*', { count: 'exact' })
    .is('member_id', null)
    .eq('is_active', 0)
    .order('created_at', { ascending: false });

  if (search) {
    query = query.or(`full_name.ilike.%${search}%,member_id.ilike.%${search}%`);
  }

  if (limit !== "All") {
    query = query.range(offset, offset + limit - 1);
  }

  const { data, count, error } = await query;

  if (error) throw error;
  return { data, count };
};

export const approveMember = async (id) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const approvalDate = new Date();
    const year = approvalDate.getFullYear();
    const month = String(approvalDate.getMonth() + 1).padStart(2, '0');
    const day = String(approvalDate.getDate()).padStart(2, '0');
    const datePart = `${year}${month}${day}`;

    // Ambil data pendaftar
    const { data: memberData, error: memberError } = await supabase
      .from('members')
      .select('member_type, full_name, email')
      .eq('id', id)
      .single();

    if (memberError) throw memberError;

    const type = memberData.member_type || 'A';
    const prefix = `KSN${type}${datePart}`;

    // 1️⃣ Ambil member_id terbesar yang punya prefix sama
    const { data: lastMember, error: lastError } = await supabase
      .from('members')
      .select('member_id')
      .like('member_id', `${prefix}%`)
      .order('member_id', { ascending: false })
      .limit(1);

    if (lastError) throw lastError;

    // 2️⃣ Hitung running number baru secara aman
    let runningNumber = 1;

    if (lastMember && lastMember.length > 0) {
      const lastId = lastMember[0].member_id;
      const lastNumber = parseInt(lastId.slice(-5)); // ambil 5 digit terakhir
      runningNumber = lastNumber + 1;
    }

    const finalMemberId = `${prefix}${String(runningNumber).padStart(5, '0')}`;

    // 3️⃣ Update data member
    const { error: updateError } = await supabase
      .from('members')
      .update({
        member_id: finalMemberId,
        is_active: 1,
        approved_at: approvalDate.toISOString(),
        approved_by: user.id
      })
      .eq('id', id);

    if (updateError) throw updateError;

    // 4️⃣ Kirim email pemberitahuan (NON-BLOCKING)
    try {
      await sendRegistrationEmail({
        email: memberData.email,
        fullName: memberData.full_name,
        memberId: finalMemberId
      });
    } catch (emailError) {
      console.error('Email failed:', emailError);
    }

    return { success: true, member_id: finalMemberId };

  } catch (error) {
    console.error('Error approving member:', error);
    return { success: false, error };
  }
};

export const rejectMember = async (id) => {
  try {
    const session = JSON.parse(localStorage.getItem('sb-session'));

    const res = await fetch(
      `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/reject-member`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY,
          'Authorization': `Bearer ${session.access_token}`,
        },
        body: JSON.stringify({ member_id: id })
      }
    );

    const result = await res.json();

    if (!res.ok || !result.success) {
      return { success: false, message: result.message || "Gagal menolak member" };
    }

    return { success: true };
  } catch (error) {
    console.error("Reject member error:", error);
    return { success: false, message: "Terjadi kesalahan sistem" };
  }
};
